<div class="ad-step1">
        <div class="container">
            <div class="level-bar pt-5 pb-5">
                <div class="half-line level-bar-active"></div>
                <div class="level level-bar-active">1</div>
                <div class="full-line"></div>
                <div class="level">2</div>
                <div class="full-line"></div>
                <div class="level">3</div>
                <div class="full-line"></div>
                <div class="level">4</div>
                <div class="full-line"></div>
                <div class="level">5</div>
                <div class="full-line"></div>
                <div class="level"><img src="assets/check-red.png" style="width: 26px; height: auto" alt=""></div>
                <div class="full-line"></div>
            </div>
            <div class="level-text">
                Step 1 of 5
            </div>
            <div class="page-contents">
                <div class="heading">
                    <h1>Welcome to Neprose</h1>
                    <p>5 steps to post ad of your property.</p>
                </div>
                <div class="form-contents">
                    <form [formGroup]="firstAdForm">
                        <h3>Basic Details</h3>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6">
                                <strong>I am</strong>
                                <div class="row mb-4">
                                    <div class="col-sm-6">
                                        <input type="radio" formControlName="iam" value="Agent">&nbsp;<span class="normal-font">Agent</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <input type="radio" formControlName="iam" value="Owner">&nbsp;<span class="normal-font">Owner</span>
                                    </div>
                                </div>
                                <strong>List My Property For</strong>
                                <div class="row mb-4">
                                    <div class="col-sm-6">
                                        <input type="radio" formControlName="listingFor" value="Sell">&nbsp;<span class="normal-font">Sale</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <input type="radio" formControlName="listingFor" value="Rent">&nbsp;<span class="normal-font">Rent</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <input type="radio" formControlName="listingFor" value="Share">&nbsp;<span class="normal-font">Share</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 mb-4">
                                <strong>Type of property</strong>
                                <select formControlName="property_type_id">
                                    <option value="null" disabled [selected]="true">Choose the type of property</option>
                                    <option *ngFor="let type of propertyTypes" [value]="type.id">{{ type.type }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row justify-content-end px-3">
                            <button type="button" [disabled]="firstAdForm.invalid" (click)="next()">Next Step &nbsp;&nbsp;&nbsp;→</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
